import { create } from 'zustand';
import type { User } from '../schemas';
import { mockUsers } from '../data/mockUsers';

interface UserState {
  users: User[];
  isLoading: boolean;
  addUser: (userData: Omit<User, 'id' | 'createdAt' | 'updatedAt'>) => void;
  updateUser: (id: string, updates: Partial<User>) => void;
  deleteUser: (id: string) => void;
  getUser: (id: string) => User | undefined;
}

export const useUserStore = create<UserState>()((set, get) => ({
  users: mockUsers,
  isLoading: false,
  addUser: userData => {
    const newUser: User = {
      ...userData,
      id: Math.random().toString(36).substr(2, 9),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    set(state => ({ users: [...state.users, newUser] }));
  },
  updateUser: (id, updates) => {
    set(state => ({
      users: state.users.map(u =>
        u.id === id ? { ...u, ...updates, updatedAt: new Date().toISOString() } : u,
      ),
    }));
  },
  deleteUser: id => {
    set(state => ({ users: state.users.filter(u => u.id !== id) }));
  },
  getUser: id => {
    return get().users.find(u => u.id === id);
  },
}));
